<template>
   <el-input
        v-model="internalKeyword"
        :placeholder="t('validate.keywordText')"
        class="search-input font18 color-f"
        clearable
    >
        <template #prepend>
            <div class="search-icon flex-center" @click="handleSearch">
                <img src="@/assets/images/icon/icon-search.webp" :alt="t('search.search')">
            </div>
        </template>
        <template #append>
            <div class="search-btn flex-center font18 color-f text-center" @click="handleSearch">
                {{t('search.search')}}
            </div>
        </template>
    </el-input>
</template>
<script lang="ts" setup>
 import { useI18n } from 'vue-i18n'
 const { locale,t } = useI18n()
import { ref } from 'vue';
import { useRoute } from 'vue-router'
const route = useRoute()
// 定义事件
const emit = defineEmits<{
    (e: 'search', keyword: string): void; // 搜索事件
}>();

// 内部关键词状态，不接受外部传入
const internalKeyword = ref<string>(route?.query?.keyword || '');

// 处理搜索
const handleSearch = () => {
    // 触发搜索事件，只在点击时触发
    emit('search', internalKeyword.value);
};
</script>
<style scoped lang="scss">
    .search-input{
        --el-input-inner-height: 48px;
        --el-input-text-color: #FFFFFF;
        box-shadow: 0px 6px 18px 0px rgba(0,0,0,0.06);
        background-color: rgba($color: #FFFFFF, $alpha: 0.1);
        &:focus-within{
            box-shadow: 0 0 0 1px rgba($color: #FFFFFF, $alpha: 0.3) inset;
        }
        :deep(.el-input-group__prepend){
            box-shadow: none;
            background-color: transparent;
            border-radius: 0;
            padding: 0 12px 0 24px;
        }
        :deep(.el-input-group__append){
            box-shadow: none;
            background-color: transparent;
            border-radius: 0;
            padding: 0;
        }
        :deep(.el-input__wrapper){
            background-color: transparent;
            box-shadow: none;
            padding: 0;
            padding-right: 10px;
        }
    }
    .search-icon{
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .search-btn{
        width: 100%;
        height: 100%;
        padding: 0 24px;
        background-color: var(--org-color);
        cursor: pointer;
    }
    @media (max-width:1200px){
        .search-input{
            font-size: 14px;
            --el-input-inner-height: 44px;
            :deep(.el-input-group__prepend){
                padding: 0 12px;
            }
        }
        .search-btn{
            font-size: 14px;
        }
    }
</style>